'use client';
import React, { useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import './style.scss';

interface ScrollShadowProps {
  children: React.ReactNode;
  className?: string;
  hideScrollBar?: boolean;
  size?: number;
}

// 滚动阴影展示

const ScrollShadow: React.FC<ScrollShadowProps> = ({ children, className }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isTopScroll, setIsTopScroll] = useState(false);
  const [isBottomScroll, setIsBottomScroll] = useState(true);

  const handleScroll = () => {
    const element = contentRef.current;
    if (!element) return;

    const { scrollTop, scrollHeight, clientHeight } = element;
    setIsTopScroll(scrollTop > 0);
    setIsBottomScroll(scrollTop < scrollHeight - clientHeight - 1);
  };

  useEffect(() => {
    const element = contentRef.current;
    if (!element) return;
    handleScroll();
    element.addEventListener('scroll', handleScroll);
    return () => element.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={classNames('scroll-shadow-wrapper')}>
      <div
        ref={contentRef}
        className={classNames('scroll-shadow-content', className)}
        onScroll={handleScroll}
        data-top-scroll={isTopScroll}
        data-bottom-scroll={isBottomScroll}
      >
        {children}
      </div>
    </div>
  );
};

export { ScrollShadow };
